import { styled } from '@mui/material/styles';

const DAY_SIZE = '36px';

export const DayWrapper = styled('div')(() => ({
  display: 'flex',
  flex: 1,
  alignItems: 'stretch'
}));

export const DayContainer = styled('button')(
  ({ theme, $disablePointer, disabled, $backgroundColor, $textColor }) => ({
    WebkitAppearance: 'none',
    alignItems: 'center',
    border: 0,
    cursor: $disablePointer ? 'default' : 'pointer',
    display: 'flex',

    // Height: matches the calculation in the template literal
    height: `calc(${DAY_SIZE} - ${theme.spacing(2 * 0.25)})`,

    justifyContent: 'center',
    flex: '1 1',
    margin: theme.spacing(0.25, 0),
    outline: 0,
    padding: 0,
    textDecoration: 'none',
    minWidth: '18px',

    ...(disabled && { pointerEvents: 'none' }),

    '&:focus': {
      backgroundColor: theme.color.grey[400]
    },

    '&:hover': {
      backgroundColor: theme.color.grey[400]
    },

    // Zoom-responsive width using CSS media queries
    '@media screen and (min-resolution: 1.25dppx)': {
      width: '29px' // 36px * 0.8 for 125% zoom
    },
    '@media screen and (min-resolution: 1.5dppx)': {
      width: '24px' // 36px * 0.67 for 150% zoom
    },
    '@media screen and (min-resolution: 1.75dppx)': {
      width: '21px' // 36px * 0.58 for 175% zoom
    },
    '@media screen and (min-resolution: 2dppx)': {
      width: '18px' // 36px * 0.5 for 200% zoom
    },

    // Webkit-based zoom detection
    '@media screen and (-webkit-min-device-pixel-ratio: 1.25)': {
      width: '29px'
    },
    '@media screen and (-webkit-min-device-pixel-ratio: 1.5)': {
      width: '24px'
    },
    '@media screen and (-webkit-min-device-pixel-ratio: 1.75)': {
      width: '21px'
    },
    '@media screen and (-webkit-min-device-pixel-ratio: 2)': {
      width: '18px'
    },

    // Firefox zoom detection
    '@media screen and (min--moz-device-pixel-ratio: 1.25)': {
      width: '29px'
    },
    '@media screen and (min--moz-device-pixel-ratio: 1.5)': {
      width: '24px'
    },

    // Apply custom colors / disabled overrides
    '&&': {
      ...($backgroundColor && { backgroundColor: $backgroundColor }),
      ...($textColor && { color: $textColor }),
      ...(disabled && {
        backgroundColor: 'transparent',
        color: theme.color.disabled.transparentText,
        cursor: 'not-allowed'
      })
    }
  })
);

export const CalendarContainer = styled('div')(() => ({
  display: 'inline-block',
  overflow: 'hidden'
}));

export const Side = styled('div')(({ theme, $backgroundColor }) => ({
  flex: '0 0 10px',
  margin: theme.spacing(0.25, 0),
  ...($backgroundColor && { backgroundColor: $backgroundColor })
}));
